<p-select
    [id] = "id()"
    [(ngModel)]="selectedProductCategoryCostKey"

    [options]="options()"
    optionLabel="productCategoryCostName"
    optionValue="productCategoryCostKey"
    dataKey="productCategoryCostKey"

    [placeholder]="isLoading() ? 'Loading product cost categories...' : placeHolder()"
    [loading]="isLoading()"
    [showClear]="true"

    [disabled]="isDisabled()"
    [invalid]="isInvalid()"

    (ngModelChange)="onModelChange($event)"
    (onBlur)="blur.emit()"
    
    fluid
    >
</p-select>
